import { render, staticRenderFns } from "./manage_customers.vue?vue&type=template&id=1984268a&"
import script from "./manage_customers.vue?vue&type=script&lang=js&"
export * from "./manage_customers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports